import { Input, Row } from 'antd';
import React, { memo } from 'react';

import DefaultFormItem from 'components/composites/DefaultFormItem';
import BackOfficeEnterpriseSelect from 'components/forms/BackOfficeEnterpriseSelect/BackOfficeEnterpriseSelect';
import BackOfficeSiteSelect from 'components/forms/BackOfficeSiteSelect/BackOfficeSiteSelect';
import FormItemCol from 'components/forms/FormItemCol';

function BarnOwlConvertFormItems(): JSX.Element {
  return (
    <>
      <Row gutter={24}>
        <BackOfficeEnterpriseSelect
          clearSiteOnChange
          placeholder="Search enterprise"
        />
      </Row>
      <Row gutter={24}>
        <BackOfficeSiteSelect
          filterByEnterprise
          label="Import cameras to site"
          placeholder="Select site"
        />
        <FormItemCol>
          <DefaultFormItem
            name="accountId"
            label="Barn Owl account ID"
            rules={[{ required: true, message: 'Please enter the Barn Owl account UUID' }]}
          >
            <Input placeholder="Account UUID" />
          </DefaultFormItem>
        </FormItemCol>
      </Row>
    </>
  );
}

export default memo(BarnOwlConvertFormItems);
